import { IVehicle } from 'data/schema';

/**
 * Helper function to check if two vehicles match based on their identifiers
 */
export function vehiclesMatch(v1: IVehicle, v2: IVehicle): boolean {
  return !!(
    (v1.prString && v1.prString === v2.prString) ||
    (v1.vinOrMarketingCode && v1.vinOrMarketingCode === v2.vinOrMarketingCode) ||
    (v1.okapiCode && v1.okapiCode === v2.okapiCode)
  );
}
